import { render, staticRenderFns } from "./t-desktop.vue?vue&type=template&id=a5c8d82a&"
import script from "./t-desktop.vue?vue&type=script&lang=js&"
export * from "./t-desktop.vue?vue&type=script&lang=js&"
import style0 from "./t-desktop.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports